import React from 'react';
import PropTypes from 'prop-types';

const BankLogo = ({ fill = '' }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="var(--SECONDARY_DARK)"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7472 4.49472V4.22686C12.7446 4.1109 12.7111 3.99773 12.6503 3.89898C12.5894 3.80024 12.5034 3.71948 12.401 3.66499L6.84765 0.822989C6.75816 0.779143 6.65983 0.756348 6.56018 0.756348C6.46053 0.756348 6.3622 0.779143 6.27272 0.822989L0.719382 3.68459C0.619782 3.73742 0.535548 3.81512 0.474871 3.91014C0.414194 4.00517 0.379139 4.11427 0.373116 4.22686V4.47512C0.373116 4.6484 0.441949 4.81458 0.564472 4.9371C0.686996 5.05962 0.853174 5.12846 1.02645 5.12846H1.98685V11.6618H1.00685C0.833574 11.6618 0.667396 11.7306 0.544873 11.8531C0.422349 11.9757 0.353516 12.1418 0.353516 12.3151C0.353516 12.4884 0.422349 12.6546 0.544873 12.7771C0.667396 12.8996 0.833574 12.9685 1.00685 12.9685H12.1135C12.2868 12.9685 12.453 12.8996 12.5755 12.7771C12.698 12.6546 12.7668 12.4884 12.7668 12.3151C12.7668 12.1418 12.698 11.9757 12.5755 11.8531C12.453 11.7306 12.2868 11.6618 12.1135 11.6618H11.1335V5.12846H12.1135C12.28 5.12353 12.4384 5.05518 12.5562 4.93739C12.674 4.81959 12.7423 4.66124 12.7472 4.49472ZM6.56018 2.12966L9.95098 3.86099H3.16938L6.56018 2.12966ZM3.29352 5.12846H5.90685V11.6618H3.29352V5.12846ZM9.82685 11.6618H7.21352V5.12846H9.82685V11.6618Z"
      fill={fill || '#D68309'}
    />
  </svg>
);

BankLogo.propTypes = {
  fill: PropTypes.string,
};

export default BankLogo;
